import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DynamicFormTemplateComponent } from './dynamicformtemplate.component';
const routes: Routes = [{ path: '', component: DynamicFormTemplateComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DynamicFormTemplateRoutingModule { }
